module.exports = __webpack_public_path__ + "static/media/empathize_ie.af5b5592.png";